import {env} from '../InjectEnv.js';

const MULE_API_BASE_URL = env.REACT_APP_MULE_API_BASE_URL;
const AEM_API_BASE_URL = env.REACT_APP_AEM_API_BASE_URL;
const OKTA_CLIENT_ID = env.REACT_APP_OKTA_CLIENT_ID;
const OKTA_ISSUER_URL = env.REACT_APP_OKTA_ISSUER_URL;
const APP_LOGIN_URL = env.REACT_APP_LOGIN_URL;
const APP_LOGOUT_URL_SESSION_EXP = env.REACT_APP_LOGOUT_URL_SESSION_EXP;
const APP_LOGOUT_URL = env.REACT_APP_LOGOUT_URL;
const VINTAGE_PREFIX = env.REACT_APP_VINTAGE_PREFIX;
const PSR_IFRAME_SRC = env.REACT_APP_PSR_IFRAME_SRC;
const PROFILE_API_BASE_URL = env.REACT_APP_PROFILE_API_BASE_URL;
const PROFILE_LOGOUT_TIME = env.REACT_APP_PROFILE_LOGOUT_TIME;
const TAX_DOCUMENTS = env.REACT_APP_TAX_DOCUMENTS;
const ANALYTICS_SCRIPT = env.REACT_APP_ANALYTICS_SCRIPT;
export {
  MULE_API_BASE_URL,
  AEM_API_BASE_URL,
  OKTA_CLIENT_ID,
  OKTA_ISSUER_URL,
  APP_LOGIN_URL,
  APP_LOGOUT_URL_SESSION_EXP,
  APP_LOGOUT_URL,
  PSR_IFRAME_SRC,
  PROFILE_API_BASE_URL,
  PROFILE_LOGOUT_TIME,
  VINTAGE_PREFIX,
  TAX_DOCUMENTS,
  ANALYTICS_SCRIPT
};
